module.exports = __webpack_public_path__ + "static/media/mw.8627c92d.svg";